import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-l1-mall-knowledge",
  "use": "icon-soc-l1-mall-knowledge-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-l1-mall-knowledge\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\">\r\n  <path d=\"M256 192h512v128H256V192zm0 160h512v480H256V352zm96 96v64h320v-64H352zm0 128v64h320v-64H352zm0 128v64h224v-64H352z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-l1-mall-knowledge.svg
// module id = lAA3
// module chunks = 491